module.exports = __webpack_public_path__ + "img/1M9.dd958e2d.png";